import { OnboardingRouteRedirect } from '../../components';

export default function Step2AboutYouRedirect() {
  return <OnboardingRouteRedirect to="/(onboarding)/step-1-about-you" />;
}
